import { fetch } from '@financial-tool/fetch';

export default function deleteExpenseAPI(id: string) {
  return fetch.delete<string>(`/expenses/${id}`, {}, false);
}
